import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import PaymentFlowContainer from './PaymentFlowContainer';
import {StyledBitPage} from './BitPage.styled';
import {useHistory} from "react-router-dom";
import {constants} from "../../common/constants/constants";


export function BitPage({match}) {
    const {buildingID, cartID} = match.params;

    const {t} = useTranslation();

    const history = useHistory();


    const tenantDetails = useSelector(state => state.tenant.details);
    const paymentPlan = useSelector(state => state.tenant.paymentPlan);
    const disabledInsurancePage = useSelector(state => state.tenant.disableInsurancePage ?? false);


    const statusPagePath = `status/${cartID}`;
    const insurancePagePath = `${constants.pages.insuranceOffer}/${buildingID}/${tenantDetails.apartmentNumber}/${cartID}`;
    const frontendUrl = window.location.origin;
    const successUrlAddress = disabledInsurancePage ? `${frontendUrl}/${statusPagePath}` : `${frontendUrl}/${insurancePagePath}`;
    const paymentTotal = paymentPlan.firstPaymentTotal;
    const url = `https://direct.tranzila.com/ptop/iframenew.php?sum=${paymentTotal}&currency=1&cred_type=1&lang=il&bit_pay=1&hide_cc=1&nologo=1&cartId=${cartID}&success_url_address=${successUrlAddress}`;

    window.addEventListener('message', (event) => {
        const data = event.data;
        const isComingFromTranzilaIframe = data === 'redirectToOrderStatusPage' || (event.source?.location.href === successUrlAddress && successUrlAddress.includes(statusPagePath));
        const isComingFromInsuranceOfferPage = data === 'redirectToInsuranceOfferPage' || (event.source?.location.href === successUrlAddress && successUrlAddress.includes(insurancePagePath));
        if (isComingFromTranzilaIframe) {
            history.push(`/${statusPagePath}`);
        } else if (isComingFromInsuranceOfferPage){
            history.push({
                pathname: `/${insurancePagePath}`,
                state: {
                    tenantName: tenantDetails.name,
                    tenantEmail: tenantDetails.email,
                    tenantPhone: tenantDetails.phone
                }
            });
        }
    });

    return (
        <StyledBitPage>
            <PaymentFlowContainer title={t('payments.payment_for')} subheader={t('payments.bit_info')}>
            </PaymentFlowContainer>
            <div className={'iframe-wrapper'}>
                <iframe title="Bit Inline Frame" allowTransparency="true" src={url}/>
            </div>
        </StyledBitPage>
    )
}

